import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi, { UPLOAD_TIMEOUT } from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import Phone from 'services/Phone'
import Address from 'services/Address'
import cutileiLogo from 'icons/cutilei-logo.png'
import { format as formatCNPJ } from '@fnando/cnpj'
import { ReactComponent as ButtonLoading } from 'icons/loading.svg'

import {
  Container,
  Form,
  Row,
  Info,
  Image,
  TextRow,
  Button,
  SubTitle,
  InfoText,
  ErrorContainer
} from '../styles'

export default function Confirmation ({
  companyData = {},
  services = []
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const [submitting, setSubmitting] = useState (false)
  const [showOkDialog, setShowOkDialog] = useState (false)
  const navigate = useNavigate ()

  const handleSubmit = async () => {
    setSubmitting (true)
    setErrorMessage (null)
    
    try {
      const { logo, email, password } = companyData

      const { data: company } = await cutileiApi.post ('/companies', companyData)
      const { data: loginData } = await cutileiApi.post ('/auth/companies', {
        email,
        password
      })

      if (logo) {
        const formData = new FormData ()
        formData.append ('profile_picture', logo.file, logo.file.name)

        await cutileiApi.put (`/companies/${company.id}/profile_picture`, formData, {
          // Upload/download nao cabe no timeout padrao: rede movel ruim leva mais que 30 s.
          timeout: UPLOAD_TIMEOUT,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      }

      setSubmitting (false)
      AuthService.signIn (loginData)
      toggleOkDialog ()
    } catch (error) {
      setSubmitting (false)
      logApiError (error)
    }
  }

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <Container style={{paddingTop: 0}}>
      <SubTitle style={{marginBottom: 15, marginTop: -10}}>
        Confirme seus dados
      </SubTitle>
      <Form style={{width: 460}}>
        <Info>
          <SubTitle>Dados da empresa</SubTitle>
          <Row style={{marginBottom: 10}}>
            <Image src={companyData.logo?.url ?? cutileiLogo}/>
          </Row>
          <TextRow>
            <SubTitle>Nome fantasia:</SubTitle>
            <InfoText>{companyData.name}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Razão social:</SubTitle>
            <InfoText>{companyData.corporate_name}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>CNPJ:</SubTitle>
            <InfoText>{formatCNPJ (companyData.cnpj)}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>E-mail:</SubTitle>
            <InfoText>{companyData.email}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Celular:</SubTitle>
            <InfoText>{Phone.formatPhone (companyData.cellphone, true)}</InfoText>
          </TextRow>
          {companyData.phone && (
            <TextRow>
              <SubTitle>Telefone:</SubTitle>
              <InfoText>{Phone.formatPhone (companyData.phone, true)}</InfoText>
            </TextRow>
          )}
        </Info>
      </Form>
      <Form style={{width: 460}}>      
        <Info>
          <SubTitle>Dados do responsável</SubTitle>
          <TextRow>
            <SubTitle>Nome:</SubTitle>
            <InfoText>{companyData.owner}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>E-mail:</SubTitle>
            <InfoText>{companyData.owner_email}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Celular:</SubTitle>
            <InfoText>{Phone.formatPhone (companyData.owner_phone, true)}</InfoText>
          </TextRow>
        </Info>
      </Form>
      <Form style={{width: 460}}>
        <Info>
          <SubTitle>Endereço</SubTitle>
          <InfoText>{Address.formatAddress (companyData.address)}</InfoText>
          <TextRow>
            <InfoText>
              CEP: {Address.formatCep (companyData.address.postal_code)}
            </InfoText>
          </TextRow>
        </Info>
      </Form>
      {errorMessage && (
        <ErrorContainer>
          <p>{errorMessage}</p>
        </ErrorContainer>
      )}
      <Button type='button' onClick={handleSubmit} disabled={submitting}>
        {submitting ? <ButtonLoading/> : 'Finalizar cadastro'}
      </Button>
      <AlertDialog
        visible={showOkDialog}
        title={`Bem-vindo à Cutilei, ${companyData.name}`}
        message={
          <>
            <InfoText>
              Sua empresa foi cadastrada com sucesso!
            </InfoText>
            <InfoText>
              Você será redirecionado para a sua área logada para prosseguir com as demais configurações assim que sua empresa for aprovada pela Cutilei.
            </InfoText>
          </>
        }
        confirmText='Ok'
        onConfirm={() => navigate ('/company', { replace: true })}
        onClose={() => navigate ('/company', { replace: true })}
      />
    </Container>
  )
}
